import { Component, DoCheck, Input, IterableDiffers, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormArray, FormBuilder, Validators } from '@angular/forms';
import { DecimalPipe } from '@angular/common';
import {
  AttendanceBox,
  FeedingBox,
  SpliceBox
} from 'src/app/simulation/state/network-parameters.model.generated';

@Component({
  selector: 'app-specification-form',
  templateUrl: './specification-form.component.html',
  styleUrls: ['./specification-form.component.scss'],
  providers: [DecimalPipe]
})
export class SpecificationFormComponent implements OnInit, DoCheck {

  @Input()
  title: string;

  @Input()
  types: Box[];

  @Input()
  fields: string[];

  @Input()
  formArray: FormArray;

  forms = this.fb.array([]);

  iterableDiffer: any;

  constructor(
    private fb: FormBuilder,
    private decimalPipe: DecimalPipe,
    differs: IterableDiffers
  ) {
    this.iterableDiffer = differs.find([]).create(null);
  }

  ngOnInit(): void {
    this.formArray.push(this.forms);
  }

  ngDoCheck(): void {
    const changes = this.iterableDiffer.diff(this.types);
    if (changes) {
      setTimeout(() => {
        this.createForm();
      }, 100);
    }
  }

  update(t: Box, v: any, index: number): void {
    t.name = `${this.title} ${this.decimalPipe.transform(index + 1, '2.0-0')}`;

    if (v.max_splitters !== undefined) {
      t.max_splitters = parseInt(v.max_splitters, 10);
    }

    if (v.cable_ports !== undefined) {
      t.cable_ports = parseInt(v.cable_ports, 10);
    }

    if (v.max_fusions !== undefined) {
      t.max_fusions = parseInt(v.max_fusions, 10);
    }

    if (v.customer_ports !== undefined) {
      t.customer_ports = parseInt(v.customer_ports, 10);
    }

    if (v.bus_ports !== undefined) {
      t.bus_ports = parseInt(v.bus_ports, 10);
    }
  }

  private createForm(): void {
    this.forms.clear();

    this.types.forEach((t, index) => {
      const form = this.fb.group({});

      if (this.fields.includes('cable_ports')) {
        form.addControl('cable_ports', this.fb.control(t.cable_ports, [Validators.required, Validators.min(2)]));
      }

      if (this.fields.includes('max_fusions')) {
        form.addControl('max_fusions', this.fb.control(t.max_fusions, [Validators.required, Validators.min(0)]));
      }

      if (this.fields.includes('max_splitters')) {
        form.addControl('max_splitters', this.fb.control(t.max_splitters, [Validators.required, Validators.min(0)]));
      }

      if (this.fields.includes('customer_ports')) {
        form.addControl('customer_ports', this.fb.control(t.customer_ports, [Validators.required, Validators.min(0)]));
      }

      if (this.fields.includes('bus_ports')) {
        form.addControl('bus_ports', this.fb.control(t.bus_ports, [Validators.required, Validators.min(0)]));
      }

      this.forms.push(form);

      form.valueChanges.subscribe(v => this.update(t, v, index));
    });
  }

}

type Box = FeedingBox | AttendanceBox | SpliceBox;
